import { render, staticRenderFns } from "./white.vue?vue&type=template&id=45003cb8&scoped=true"
import script from "./white.vue?vue&type=script&lang=js"
export * from "./white.vue?vue&type=script&lang=js"
import style0 from "./white.vue?vue&type=style&index=0&id=45003cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45003cb8",
  null
  
)

export default component.exports